import { Component, inject } from '@angular/core';
import { AlertAlreadyConnectedComponent } from '../connect/atoms/alert-already-connected/alert-already-connected.component';
import { Location } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AccountService, CreateTikTokAccountTikApiIn } from '../../services/account/account.service';
import { firstValueFrom } from 'rxjs';
import { StorageService } from '../../services/storage/storage.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-enter-tiktok',
  standalone: true,
  imports: [AlertAlreadyConnectedComponent, FormsModule],
  templateUrl: './enter-tiktok.component.html',
  styleUrl: './enter-tiktok.component.scss'
})
export class EnterTiktokComponent {

  location: Location = inject(Location);
  accountService: AccountService = inject(AccountService);
  storageService: StorageService = inject(StorageService);
  router: Router = inject(Router);
  
  alreadyConnectedError: {
    title: string,
    icon: string,
    action: string,
  } | undefined;

  tiktokHandle: string | undefined;
  errorMessage: string | undefined;

  fetchingAccount: boolean = false;


  connectTikTok() {

    const handle = (this.tiktokHandle ?? '').trim();
    if (!handle) return;

    else {
      console.log('tiktokHandle: ', handle);
      void this.sendTikTokHandle(handle);
    }
  }

  async sendTikTokHandle(tt_handle: string) {
    this.fetchingAccount = true;

    const externalId = this.storageService.get('externalId');
    const businessId = this.storageService.get('businessId');

    const body: CreateTikTokAccountTikApiIn = {
      externalId: externalId!,
      businessId: businessId!,
      handle: tt_handle!
    }

    try {
      const createTikTokAccountTikApi_response = await firstValueFrom(this.accountService.createTikTokAccountTikApi(body))
      console.log('Create TikTok account TikApi response: ', createTikTokAccountTikApi_response);
      this.accountService.enterTiktok = createTikTokAccountTikApi_response;
      this.fetchingAccount = false;
      this.router.navigate(['/enter-tiktok-complete']);
    } catch (createTikTokAccountTikApi_error) {
      console.error('Error creating TikTok account: ', createTikTokAccountTikApi_error);
      this.fetchingAccount = false;
      this.errorMessage = 'Error creating TikTok account';
    }

  }

  goBack() {
    this.location.back();
  }

}
